import { TableColumn } from '../../models';
import { MultiBadgeCellComponent, MultiBadgeCellProps } from './multi-badge.component';

export class MultiBadgeColumn<I> extends TableColumn<I, MultiBadgeCellProps> {
  readonly component = MultiBadgeCellComponent;
}
